module.exports = __webpack_public_path__ + "static/media/outsite-btn@2x.a4dc45a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/outsite-btn@2x.png
// module id = 1024
// module chunks = 0